import React, { useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { salesApi, apiError } from '../salesApi';
import { useT } from '../salesI18n';

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const { t } = useT();
  const [cur, setCur] = useState('');
  const [nxt, setNxt] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await salesApi.post('/auth/change-password', { current_password: cur, new_password: nxt });
      toast.success(t.passwordChanged);
      setCur(''); setNxt('');
      onOpenChange(false);
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog" className="max-w-sm">
        <DialogHeader><DialogTitle className="font-display">{t.changePassword}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>{t.currentPassword}</Label>
            <Input data-testid="change-password-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="h-11 mt-1" required />
          </div>
          <div>
            <Label>{t.newPassword}</Label>
            <Input data-testid="change-password-new" type="password" value={nxt} onChange={(e) => setNxt(e.target.value)} className="h-11 mt-1" required minLength={4} />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="outline" className="h-11" onClick={() => onOpenChange(false)}>{t.cancel}</Button>
            <Button type="submit" className="h-11 font-semibold" disabled={busy} data-testid="change-password-submit">{t.save}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
